import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentSelectedHumanPerformanceDto extends EpimsBaseEntityDto {
    
  EventTypeId: string;
  HumanPerformanceId: string;
  HumanPerformanceName: string;  
   
    
IncidentTrackingNo: string;
    

}